// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3237":"db8b48cf","3822":"791686df","5363":"f496a6e1","6523":"b0878441","8654":"b0878441"}[chunkId] + ".chunk.css";
};